import { format } from 'date-fns'
import moment from 'moment-timezone'

class Schedule {
    constructor(props){
        let updatedProps = props || {}
        this.scheduleID = updatedProps.scheduleID
        this.userID = updatedProps.userID;
        // this.date = updatedProps.date && format(new Date(updatedProps.date), 'LLL d Y') || format(new Date(), 'LLL d Y');
        this.date = updatedProps.date && moment(updatedProps.date).format('MMM D Y') || moment().format('MMM D Y')
        this.items = updatedProps.items || [];
        this.notes = updatedProps.notes
    }
}

export default Schedule
